webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(131);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(116);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(60);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(59);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(64);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(65);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(67);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(66);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _firebase = __webpack_require__(16);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _events = __webpack_require__(47);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatRepository = function (_EventEmitter) {
	  (0, _inherits3.default)(CatRepository, _EventEmitter);
	
	  function CatRepository() {
	    (0, _classCallCheck3.default)(this, CatRepository);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CatRepository.__proto__ || (0, _getPrototypeOf2.default)(CatRepository)).call(this));
	
	    _this.ref = new _firebase2.default('https://uniquitty-10845.firebaseio.com/cats');
	    _this.attachFirebaseListeners();
	    _this.sortOrder = 'common';
	    return _this;
	  }
	
	  (0, _createClass3.default)(CatRepository, [{
	    key: 'attachFirebaseListeners',
	    value: function attachFirebaseListeners() {
	      this.ref.orderByChild('number').on('child_added', this.onAdded, this);
	      this.ref.on('child_removed', this.onRemoved, this);
	      this.ref.orderByChild('number').on('child_changed', this.onChanged, this);
	    }
	  }, {
	    key: 'sortByUnique',
	    value: function sortByUnique() {
	      this.sortOrder = 'unique';
	    }
	  }, {
	    key: 'sortByCommon',
	    value: function sortByCommon() {
	      this.sortOrder = 'common';
	    }
	  }, {
	    key: 'getSortOrder',
	    value: function getSortOrder() {
	      return this.sortOrder;
	    }
	  }, {
	    key: 'create',
	    value: function create(_ref, onComplete) {
	      var _ref$name = _ref.name,
	          name = _ref$name === undefined ? '' : _ref$name;
	
	      this.ref.child(name).set({
	        number: 1
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update(_ref2, onComplete) {
	      var _ref2$snapshot = _ref2.snapshot,
	          snapshot = _ref2$snapshot === undefined ? '' : _ref2$snapshot,
	          _ref2$name = _ref2.name,
	          name = _ref2$name === undefined ? '' : _ref2$name;
	
	      var newNumber = snapshot.val().number + 1;
	      var newObj = {
	        number: newNumber
	      };
	      this.ref.child(name).set(newObj);
	    }
	  }, {
	    key: 'onAdded',
	    value: function onAdded(snapshot) {
	      var cat = this.snapshotToCat(snapshot);
	      this.emit('added', cat);
	    }
	  }, {
	    key: 'onRemoved',
	    value: function onRemoved(oldSnapshot) {
	      var cat = this.snapshotToCat(oldSnapshot);
	      this.emit('removed', cat);
	    }
	  }, {
	    key: 'onChanged',
	    value: function onChanged(snapshot) {
	      var cat = this.snapshotToCat(snapshot);
	      this.emit('changed', cat);
	    }
	  }, {
	    key: 'snapshotToCat',
	    value: function snapshotToCat(snapshot) {
	      var key = snapshot.key();
	      var cat = snapshot.val();
	      cat.key = key;
	      return cat;
	    }
	  }, {
	    key: 'findIndex',
	    value: function findIndex(cats, key) {
	      return cats.findIndex(function (note) {
	        return note.key === key;
	      });
	    }
	  }, {
	    key: 'find',
	    value: function find(cats, key) {
	      return cats.find(function (note) {
	        return note.key === key;
	      });
	    }
	  }, {
	    key: 'regrabItems',
	    value: function regrabItems() {
	      var _this2 = this;
	
	      this.ref.orderByChild('number').once('value', function (snapshot) {
	
	        var data = snapshot.val();
	        var done = (0, _keys2.default)(data).map(function (key) {
	          var object = {
	            number: data[key].number,
	            key: key
	          };
	          return object;
	        });
	
	        if (_this2.sortOrder === 'common') {
	          done = done.sort(function (a, b) {
	            return a.number - b.number;
	          });
	        } else {
	          done = done.sort(function (a, b) {
	            return b.number - a.number;
	          });
	        }
	
	        done.map(function (e) {
	          _this2.emit('added', e);
	        });
	      });
	    }
	  }]);
	  return CatRepository;
	}(_events2.default);
	
	exports.default = new CatRepository();

/***/ },
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(105)
	
	/* script */
	__vue_exports__ = __webpack_require__(51)
	
	/* template */
	var __vue_template__ = __webpack_require__(123)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(121);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Index = __webpack_require__(118);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Create = __webpack_require__(117);
	
	var _Create2 = _interopRequireDefault(_Create);
	
	var _Unique = __webpack_require__(119);
	
	var _Unique2 = _interopRequireDefault(_Unique);
	
	var _About = __webpack_require__(120);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Cats: _Index2.default,
	    CreateCatForm: _Create2.default,
	    Unique: _Unique2.default,
	    UniquittyHeader: _Header2.default,
	    About: _About2.default
	  }
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['cat'],
	  computed: {
	    catNumber: function catNumber() {
	      return this.cat.number > 1 ? this.cat.number : 'UNIQUE';
	    }
	  }
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(16);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _CatRepository = __webpack_require__(17);
	
	var _CatRepository2 = _interopRequireDefault(_CatRepository);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var firebase = new _firebase2.default('https://uniquitty-10845.firebaseio.com/');
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '',
	      foundBadWord: false,
	      stringTooLong: false,
	      badWord: ''
	    };
	  },
	
	  methods: {
	    upperCaseFirst: function upperCaseFirst(str) {
	      return str.charAt(0).toUpperCase() + str.substring(1);
	    },
	    profanityFilter: function profanityFilter(text) {
	      var profanity = ['cunt', 'pussy', 'whore', 'arse', 'asshole', 'arsehole', 'wanker', 'wank', 'wanking', 'cock', 'dick', 'nigger', 'chink', 'jew', 'fuck', 'fuckface', 'fucker', 'motherfucker', 'bitch', 'bastard', 'clit', 'fucking', 'shit', 'shite', 'gobshite', 'choad', 'tranny', 'faggot', 'fag', 'homo', 'paki', 'slitty face', 'fuk', 'cocksucker', 'dicksucker', 'clitsucker', 'cum', 'semen', 'titties', 'tits', 'shoe me dem penguin titties', 'tit', 'boobs', 'boob', 'bender', 'clunge', 'jap', 'japs eye', 'penis', 'shlong', 'niggerfaggot', 'bumbaclat', 'cracker', 'turk', 'yank', 'nazi', 'bumder', 'cuntflaps', 'twat', 'snatch', 'http', 'https', ':', '.com', '.co', '/', 'pussay', 'cnut', 'c u n t', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, '<', '>', '£', '"', '\\', '\'', '!', '$', '%', '^', '&', '*', '(', ')', '-', '_', '=', '+', '#', ':', ';', '@', '?', '|', '¬', '`', 'Kim Jung', 'Anne Frank', 'ass', 'na zi', 'Hitler', 'd i c k', 'test', 'puss y', 'p u s s y', 'of the', 'Annie Frankie', 'Princess Annie', 'sucks', 'peenis', 'hitler', 'peenus', 'anus', 'Vos', 'pu ssy', 'lmao', 'penls', 'satan', 'bung hole', 'ashole'];
	
	      var re = new RegExp(' ', 'g');
	      for (var word in profanity) {
	        if (text.replace(re, '').includes(profanity[word])) {
	          return {
	            containsProfanity: true,
	            badWord: profanity[word]
	          };
	        }
	      }
	
	      return {
	        containsProfanity: false
	      };
	    },
	    createCat: function createCat() {
	      var _this = this;
	
	      this.name = this.name.replace(/[^\x00-\x7F]/g, "");
	      this.name = this.upperCaseFirst(this.name.toLowerCase());
	
	      if (this.name.trim()) {
	
	        if (this.name.length > 24) {
	          this.stringTooLong = true;
	          return;
	        } else {
	          this.stringTooLong = false;
	        }
	
	        var profanityCheck = this.profanityFilter(this.name.toLowerCase());
	
	        if (profanityCheck.containsProfanity) {
	          this.badWord = profanityCheck.badWord;
	          this.foundBadWord = true;
	          return;
	        } else {
	          this.foundBadWord = false;
	        }
	
	        var newCat = {};
	
	        newCat[this.name] = {
	          number: 1
	        };
	
	        var catQuery = 'cats/' + this.name;
	
	        firebase.child(catQuery).once('value', function (snapshot) {
	          if (snapshot.exists()) {
	            _CatRepository2.default.update({ snapshot: snapshot, name: _this.name }, function (err) {
	              if (err) throw err;
	              _this.name = '';
	            });
	          } else {
	            _CatRepository2.default.create({ name: _this.name }, function (err) {
	              if (err) throw err;
	              _this.name = '';
	            });
	          }
	        });
	
	        this.name = '';
	      }
	    }
	  }
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _masonryLayout = __webpack_require__(48);
	
	var _masonryLayout2 = _interopRequireDefault(_masonryLayout);
	
	var _events = __webpack_require__(47);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _Cat = __webpack_require__(49);
	
	var _Cat2 = _interopRequireDefault(_Cat);
	
	var _CatRepository = __webpack_require__(17);
	
	var _CatRepository2 = _interopRequireDefault(_CatRepository);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Cat: _Cat2.default
	  },
	
	  data: function data() {
	    return {
	      cats: [],
	      uniqueSort: false,
	      commonSort: true
	    };
	  },
	
	
	  methods: {
	    sortByUnique: function sortByUnique() {
	      this.commonSort = false;
	      this.uniqueSort = true;
	
	      this.cats = [];
	
	      _CatRepository2.default.sortByUnique();
	      _CatRepository2.default.regrabItems();
	    },
	    sortByCommon: function sortByCommon() {
	      this.uniqueSort = false;
	      this.commonSort = true;
	
	      this.cats = [];
	
	      _CatRepository2.default.sortByCommon();
	      _CatRepository2.default.regrabItems();
	    }
	  },
	
	  watch: {
	    cats: {
	      handler: function handler() {
	        var _this = this;
	
	        this.$nextTick(function () {
	          _this.masonry.reloadItems();
	          _this.masonry.layout();
	        });
	      },
	
	      deep: true
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.masonry = new _masonryLayout2.default(this.$refs.catref, {
	      itemSelector: '.cat',
	      gutter: 35,
	      percentPosition: true
	    });
	
	    _CatRepository2.default.on('added', function (cat) {
	      _this2.cats.unshift(cat);
	    });
	
	    _CatRepository2.default.on('changed', function (_ref) {
	      var key = _ref.key,
	          title = _ref.title,
	          content = _ref.content;
	
	      var outdatedCat = _CatRepository2.default.find(_this2.cats, key);
	      var oldNumber = outdatedCat.number;
	      outdatedCat.number = oldNumber + 1;
	      _this2.cats = [];
	      _CatRepository2.default.regrabItems();
	    });
	  }
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _masonryLayout = __webpack_require__(48);
	
	var _masonryLayout2 = _interopRequireDefault(_masonryLayout);
	
	var _Cat = __webpack_require__(49);
	
	var _Cat2 = _interopRequireDefault(_Cat);
	
	var _CatRepository = __webpack_require__(17);
	
	var _CatRepository2 = _interopRequireDefault(_CatRepository);
	
	var _firebase = __webpack_require__(16);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Cat: _Cat2.default
	  },
	
	  props: ['title'],
	
	  data: function data() {
	    return {
	      cats: []
	    };
	  },
	
	
	  watch: {
	    cats: {
	      handler: function handler() {
	        var _this = this;
	
	        this.$nextTick(function () {
	          _this.masonry.reloadItems();
	          _this.masonry.layout();
	        });
	      },
	
	      deep: true
	    }
	  },
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.masonry = new _masonryLayout2.default(this.$refs.catref, {
	      itemSelector: '.cat',
	      gutter: 32
	    });
	
	    _CatRepository2.default.on('added', function (cat) {
	      if (cat.number === 0) {
	        _this2.cats.unshift(cat);
	      }
	    });
	
	    _CatRepository2.default.on('changed', function (_ref) {
	      var key = _ref.key,
	          title = _ref.title,
	          content = _ref.content;
	
	      var outdatedCat = _CatRepository2.default.find(_this2.cats, key);
	      if (outdatedCat && outdatedCat.number === 0) {
	        cats.filter(function (a) {
	          return a.key != key;
	        });
	      }
	    });
	  }
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(16);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _modal = __webpack_require__(122);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  components: {
	    Modal: _modal2.default
	  },
	
	  data: function data() {
	    return {
	      numberOfUsers: 0,
	      showWhatModal: false,
	      showHowModal: false,
	      showWhoModal: false
	    };
	  },
	
	
	  computed: {
	    peopleText: function peopleText() {
	      return this.numberOfUsers > 1 ? 'cats' : 'cat';
	    }
	  },
	
	  mounted: function mounted() {
	    var listRef = new Firebase('https://uniquitty-10845.firebaseio.com/presence/');
	    var userRef = listRef.push();
	
	    var presenceRef = new Firebase("https://uniquitty-10845.firebaseio.com/.info/connected");
	    presenceRef.on("value", function (snap) {
	      if (snap.val()) {
	        userRef.onDisconnect().remove();
	        userRef.set(true);
	      }
	    });
	
	    listRef.on("value", function (snap, err) {
	      this.numberOfUsers = snap.numChildren();
	    }, this);
	  }
	};

/***/ },
/* 56 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['show'],
	  data: function data() {
	    return {
	      comment: ''
	    };
	  },
	  methods: {
	    close: function close() {
	      this.show = false;
	    }
	  }
	};

/***/ },
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 106 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 107 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 108 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 109 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 110 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 111 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 112 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(109)
	
	/* script */
	__vue_exports__ = __webpack_require__(50)
	
	/* template */
	var __vue_template__ = __webpack_require__(127)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(111)
	
	/* script */
	__vue_exports__ = __webpack_require__(52)
	
	/* template */
	var __vue_template__ = __webpack_require__(129)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(108)
	
	/* script */
	__vue_exports__ = __webpack_require__(53)
	
	/* template */
	var __vue_template__ = __webpack_require__(126)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(110)
	
	/* script */
	__vue_exports__ = __webpack_require__(54)
	
	/* template */
	var __vue_template__ = __webpack_require__(128)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(107)
	
	/* script */
	__vue_exports__ = __webpack_require__(55)
	
	/* template */
	var __vue_template__ = __webpack_require__(125)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(106)
	
	/* template */
	var __vue_template__ = __webpack_require__(124)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(112)
	
	/* script */
	__vue_exports__ = __webpack_require__(56)
	
	/* template */
	var __vue_template__ = __webpack_require__(130)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "cat"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.cat.key))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.catNumber))])])
	},staticRenderFns: []}

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('span', {
	    attrs: {
	      "data-text": "U"
	    }
	  }), _vm._v(" "), _c('span', {
	    attrs: {
	      "data-text": "N"
	    }
	  }), _vm._v(" "), _c('span', {
	    attrs: {
	      "data-text": "I"
	    }
	  }), _vm._v(" "), _c('span', {
	    attrs: {
	      "data-text": "Q"
	    }
	  }), _vm._v(" "), _c('span', {
	    attrs: {
	      "data-text": "I"
	    }
	  }), _vm._v(" "), _c('span', {
	    attrs: {
	      "data-text": "T"
	    }
	  }), _vm._v(" "), _c('span', {
	    attrs: {
	      "data-text": "T"
	    }
	  }), _vm._v(" "), _c('span', {
	    attrs: {
	      "data-text": "Y"
	    }
	  }), _vm._v(" "), _c('span', {
	    attrs: {
	      "data-text": "🐱"
	    }
	  })])])
	}]}

/***/ },
/* 125 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "about"
	  }, [(_vm.showWhatModal) ? _c('modal', {
	    on: {
	      "close": function($event) {
	        _vm.showWhatModal = false
	      }
	    }
	  }, [_c('h3', {
	    slot: "header"
	  }, [_vm._v("What is this site?")]), _vm._v(" "), _c('p', {
	    slot: "body"
	  }, [_vm._v("\n      Uniqitty /uni'kitty/ is a real-time cat name storage app. "), _c('br'), _c('br'), _vm._v("\n      Some cat owners think of some great names for their cats. I felt like it'd be interesting to showcase these and learn some Vue.js at the same time."), _c('br'), _c('br'), _vm._v("\n      If you enjoy Uniqitty - consider "), _c('a', {
	    attrs: {
	      "href": "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=FWTPPZ352LBMC"
	    }
	  }, [_vm._v("donating")]), _vm._v(" to give more functionality!\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.showHowModal) ? _c('modal', {
	    on: {
	      "close": function($event) {
	        _vm.showHowModal = false
	      }
	    }
	  }, [_c('h3', {
	    slot: "header"
	  }, [_vm._v("How do I use Uniqitty?")]), _vm._v(" "), _c('p', {
	    slot: "body"
	  }, [_vm._v("Just add your cats name in the box below!"), _c('br'), _vm._v("If you have more than one, feel free to add that one too."), _c('br'), _c('br'), _c('small', [_vm._v("Try not to spam or fill it with junk..")])])]) : _vm._e(), _vm._v(" "), (_vm.showWhoModal) ? _c('modal', {
	    on: {
	      "close": function($event) {
	        _vm.showWhoModal = false
	      }
	    }
	  }, [_c('h3', {
	    slot: "header"
	  }, [_vm._v("Who made this?")]), _vm._v(" "), _c('p', {
	    slot: "body"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.chrisgregori.co.uk"
	    }
	  }, [_vm._v("Chris Gregori")]), _vm._v(" | "), _c('a', {
	    attrs: {
	      "href": "https://twitter.com/_ChrisGreg"
	    }
	  }, [_vm._v("@_ChrisGreg")]), _c('br'), _c('br'), _vm._v("I am a Software Engineer who's enjoys making silly little apps."), _c('br'), _c('small', [_vm._v("Donate or follow me on various networks if you'd like to keep up with my projects")])]), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', {
	    on: {
	      "click": function($event) {
	        _vm.showWhatModal = true
	      }
	    }
	  }, [_vm._v("What?")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.showHowModal = true
	      }
	    }
	  }, [_vm._v("How?")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.showWhoModal = true
	      }
	    }
	  }, [_vm._v("Who?")])]), _vm._v(" "), _c('h3', {
	    staticClass: "online"
	  }, [_vm._v("Currently "), _c('span', {
	    staticClass: "cool-cats"
	  }, [_vm._v(_vm._s(_vm.numberOfUsers) + " cool " + _vm._s(_vm.peopleText))]), _vm._v(" online looking at cool cats.")])])
	},staticRenderFns: []}

/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "cats"
	  }, [_c('div', {
	    staticClass: "headings"
	  }, [_c('h2', [_vm._v("Our "), _c('span', {
	    staticClass: "not-on-mobile"
	  }, [_vm._v("Unique and Common")]), _vm._v(" Kitties "), _c('span', {
	    staticClass: "not-on-mobile"
	  }, [_vm._v(" - " + _vm._s(_vm.cats.length) + " entries")])]), _vm._v(" "), _c('h2', [_vm._v("Sort by:\n      "), _c('span', {
	    staticClass: "sort",
	    class: {
	      active: _vm.uniqueSort
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortByUnique()
	      }
	    }
	  }, [_vm._v("Unique")]), _vm._v("\n      |\n      "), _c('span', {
	    staticClass: "sort",
	    class: {
	      active: _vm.commonSort
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortByCommon()
	      }
	    }
	  }, [_vm._v("Common")])])]), _vm._v(" "), _c('div', {
	    ref: "catref"
	  }, _vm._l((_vm.cats), function(cat) {
	    return _c('cat', {
	      attrs: {
	        "cat": cat
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ },
/* 127 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('UniquittyHeader'), _vm._v(" "), _c('about'), _vm._v(" "), _c('create-cat-form'), _vm._v(" "), _c('div', {
	    staticClass: "display-data"
	  }, [_c('cats')])])
	},staticRenderFns: []}

/***/ },
/* 128 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "cats"
	  }, [_c('h2', [_vm._v("Unique Kitties")]), _vm._v(" "), _c('div', {
	    ref: "catref"
	  }, _vm._l((_vm.cats), function(cat) {
	    return _c('cat', {
	      attrs: {
	        "cat": cat
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ },
/* 129 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('form', {
	    staticClass: "create-cat",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createCat()
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    attrs: {
	      "name": "title",
	      "placeholder": "Your Cats Name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("+")])]), _vm._v(" "), (_vm.foundBadWord) ? _c('div', {
	    staticClass: "bad-word"
	  }, [_vm._v("\n    For shame, detected the word '" + _vm._s(_vm.badWord) + "' which isn't allowed.\n    "), _c('br'), _c('small', [_vm._v("Cat's have feelings too 😿")])]) : _vm._e(), _vm._v(" "), (_vm.stringTooLong) ? _c('div', {
	    staticClass: "bad-word"
	  }, [_vm._v("\n    Only names 25 characters or less can be accepted\n  ")]) : _vm._e(), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "social"
	  }, [_c('div', {
	    staticClass: "container fb-like",
	    staticStyle: {
	      "padding-bottom": "0.5%"
	    },
	    attrs: {
	      "data-href": "https://uniqitty.com",
	      "data-layout": "button_count",
	      "data-action": "like",
	      "data-show-faces": "true",
	      "data-share": "true"
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "twitter-share-button",
	    attrs: {
	      "href": "https://twitter.com/share",
	      "data-text": "Check out Uniqitty to see if your cat name is unique!",
	      "data-url": "https://uniqitty.com",
	      "data-hashtags": "Uniqitty",
	      "data-show-count": "false"
	    }
	  }, [_vm._v("Tweet")])])
	}]}

/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-container"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._t("header", [_vm._v("\n            Title Goes Here\n          ")])], true), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body", [_vm._v("\n            Insert Text Here\n          ")])], true), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "modal-default-button",
	    on: {
	      "click": function($event) {
	        _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n              Cool\n            ")])])])])])])
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.3151a54fccf089108ead.js